var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSignal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5L13 13.5",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69556 3.59192C7.12749 3.53071 7.5632 3.50005 7.99945 3.50018C10.4078 3.4949 12.7204 4.44253 14.4325 6.13622",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56653 6.13622C2.41554 5.29632 3.42128 4.63139 4.52663 4.1792",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50745 6.68492C10.5661 6.94955 11.5347 7.49252 12.3128 8.25754",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68616 8.25754C4.52878 7.42916 5.59323 6.86249 6.75093 6.62598",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8075 10.3789C6.37113 9.84081 7.1129 9.52875 7.89166 9.50205C8.67043 9.47535 9.43183 9.73587 10.031 10.2341",
    stroke: "#103045",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99963 13.25C8.41385 13.25 8.74963 12.9142 8.74963 12.5C8.74963 12.0858 8.41385 11.75 7.99963 11.75C7.58542 11.75 7.24963 12.0858 7.24963 12.5C7.24963 12.9142 7.58542 13.25 7.99963 13.25Z",
    fill: "#103045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSignal);
export default __webpack_public_path__ + "static/media/noSignal.a19581a505eac12651053195a6675746.svg";
export { ForwardRef as ReactComponent };